import React, { useState } from "react"
import styled from "styled-components"
import axios from "axios"

import {
  FormContainer,
  AbsoluteImg,
  H2,
  NextStep,
} from "../general/GeneralStyles"
import Step1 from "./Step1"
import Step2 from "./Step2"
import Step3 from "./Step3"
import Step4 from "./Step4"

const FormWrapper = styled.div`
  position: relative;

  > img {
    position: absolute;
    right: 0;
    top: 50px;
  }

  ${H2} {
    margin-top: 19px;
  }

  > div > div {
    max-width: 570px;
  }
`

const PaintDrop = styled(AbsoluteImg)``

const SignUpForm = props => {
  const [formData, setFormData] = useState({})
  const [step, setStep] = useState(1)

  const inputHandler = e => {
    e.persist()
    if (e.target.name == "home_zip" && e.target.value.length == 5) {
      setFormData({ ...formData, [e.target.name]: e.target.value })
      axios
        .get(
          "https://maps.googleapis.com/maps/api/geocode/json?address=" +
            e.target.value +
            "&key=AIzaSyCUuV_NnOnGjtU5fcKX8lUE1DRDRswdFKo",
          {}
        )
        .then(response => {
          console.log(e.target.value, e.target.name)

          setFormData({
            ...formData,
            [e.target.name]: e.target.value,
            state: response.data.results[0].address_components[3].long_name,
            city: response.data.results[0].address_components[1].long_name,
          })
          console.log(response.data)
        })
        .catch(error => console.log(error))
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value })
    }
  }

  const searchZip = () => {}

  return (
    <FormWrapper>
      <PaintDrop src="/images/absolute/signupImage.png" alt="" />
      <FormContainer>
        {step == 1 ? (
          <Step1
            setStep={setStep}
            setFormData={setFormData}
            formData={formData}
            inputHandler={inputHandler}
          />
        ) : null}
        {step == 2 ? (
          <Step2
            setStep={setStep}
            setFormData={setFormData}
            formData={formData}
            inputHandler={inputHandler}
          />
        ) : null}
        {step == 3 ? (
          <Step3
            setStep={setStep}
            setFormData={setFormData}
            formData={formData}
            inputHandler={inputHandler}
          />
        ) : null}
        {step == 4 ? <Step4 formData={formData} /> : null}
      </FormContainer>
    </FormWrapper>
  )
}

export default SignUpForm
